import { Component, ReactNode } from "react";

export class ErrorBoundary extends Component<{children:ReactNode},{error:any}> {
  state={error:null};
  
  static getDerivedStateFromError(error:any){
    return {error};
  }

  render(){ 
    if (this.state.error) {
      return (
        <div style={{padding: '2rem', background: '#1a0000', color: '#ffc0c0', border: '1px solid #ff4d4d'}}>
          <h2 style={{color: 'white'}}>Error de Renderizado</h2>
          <pre style={{whiteSpace: 'pre-wrap', wordBreak: 'break-all'}}>
            {String(this.state.error)}
            {this.state.error.stack && `\n\n${this.state.error.stack}`}
          </pre>
        </div>
      )
    }
    return this.props.children; 
  }
}
